import { render, staticRenderFns } from "./modal-transfer.vue?vue&type=template&id=0fb99e62&"
import script from "./modal-transfer.vue?vue&type=script&lang=js&"
export * from "./modal-transfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports